import i18n from "../../i18n"; // Import the initialized i18n instance
import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const storedLanguage = localStorage.getItem("language") || "ar";
  const [currentLanguage, setCurrentLanguage] = useState(storedLanguage);

  useEffect(() => {
    // Save language to localStorage
    localStorage.setItem("language", currentLanguage);
    i18n.changeLanguage(currentLanguage); // Ensure i18n updates immediately
  }, [currentLanguage]);

  useEffect(() => {
    const direction = currentLanguage === "ar" ? "rtl" : "ltr";
    localStorage.setItem("direction", direction);

    document.documentElement.dir = direction;
    document.documentElement.lang = currentLanguage;
  }, [currentLanguage]);

  return (
    <LanguageContext.Provider value={{ currentLanguage, setCurrentLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
